<div *ngIf="show && !mobile"
  class="block border_customize_card border-2 overflow-hidden z-50 my-4 max-w-sm text-base list-none card_color rounded-lg shadow-lg"
  id="apps-dropdown" style="position: absolute; top: 60px; right: 10px;" data-popper-placement="bottom">
  <div class="block py-2 px-4 text-lg font-medium text-left text_white">
    Bonos
  </div>
  <div>
    <div class="text_white px-4 rounded-lg shadow-md gap-6">
      <div class="space-y-2">
        <div *ngFor="let bono of bonos" class="button_color shadow-lg shadow-gray-200 rounded-lg p-2">
          <!-- Listado de elementos (como "Bonos") -->
          <dl class="grid grid-cols-2 gap-12 sm:grid-cols-2">
            <!-- Elemento 1 -->
            <div class="flex items-center space-x-2">
              <dd class="text-sm font-semibold text_gray flex items-center gap-2">
                <span class="text_blue card_color px-2 py-1 rounded-full text-xl">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-gift">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
                    <path d="M12 8l0 13" />
                    <path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7" />
                    <path d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5" />
                  </svg>
                </span>
                <span class="font-medium text_white">
                  Bono
                  <p class="text-sm font-normal">{{bono.createdAt | date:'dd-MM-yyyy'}}</p>
                </span>
              </dd>
            </div>

            <!-- Elemento 2 -->
            <div class="flex items-center space-x-2">
              <dd class="text-sm font-semibold text_gray flex items-center gap-2">
                <span class="text_yellow text-xl gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-poker-chip">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                    <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                    <path d="M12 3v4" />
                    <path d="M12 17v4" />
                    <path d="M3 12h4" />
                    <path d="M17 12h4" />
                    <path d="M18.364 5.636l-2.828 2.828" />
                    <path d="M8.464 15.536l-2.828 2.828" />
                    <path d="M5.636 5.636l2.828 2.828" />
                    <path d="M15.536 15.536l2.828 2.828" />
                  </svg>
                </span>
                <span class="font-medium text_white">{{bono.creditsAmount | number}}</span>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
    <!-- Más elementos de notificación aquí -->
  </div>

  <a (click)="redirectToTransactions()"
    class="transition-all duration-200 mx-4 my-2 block py-2 font-normal text-center text_white hover:text_black button_color_customize hover:button_color_customize font-medium rounded-lg">
    <div class="inline-flex items-center">Ver más</div>
  </a>
</div>

<div *ngIf="show && mobile" class="card_color rounded-xl my-2 w-full py-6 px-4 text_white">
  <h2 class="text-md font-semibold mb-4 text-left ml-1">Bonos</h2>

  <div class="text_white rounded-lg shadow-md gap-6">
    <div class="space-y-2">
      <div  *ngFor="let bono of bonos" class="button_color_m shadow-lg shadow-gray-200 rounded-lg p-2">
        <!-- Listado de elementos (como "Bonos") -->
        <dl class="grid grid-cols-2 gap-12 sm:grid-cols-2">
          <!-- Elemento 1 -->
          <div class="flex items-center space-x-2">
            <dd class="text-sm font-semibold text_gray flex items-center gap-2">
              <span class="text_blue card_color px-2 py-1 rounded-full text-xl">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-gift">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
                  <path d="M12 8l0 13" />
                  <path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7" />
                  <path d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5" />
                </svg>
              </span>
              <span class="font-medium text_white">
                Bono
                <p class="text-sm font-normal">{{bono.createdAt | date:'dd-MM-yyyy'}}</p>
              </span>
            </dd>
          </div>

          <!-- Elemento 2 -->
          <div class="flex items-center space-x-2">
            <dd class="text-sm font-semibold text_gray flex items-center gap-2">
              <span class="text_yellow text-xl gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-poker-chip">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                  <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                  <path d="M12 3v4" />
                  <path d="M12 17v4" />
                  <path d="M3 12h4" />
                  <path d="M17 12h4" />
                  <path d="M18.364 5.636l-2.828 2.828" />
                  <path d="M8.464 15.536l-2.828 2.828" />
                  <path d="M5.636 5.636l2.828 2.828" />
                  <path d="M15.536 15.536l2.828 2.828" />
                </svg>
              </span>
              <span class="font-medium text_white">{{bono.creditsAmount | number}}</span>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>

  <a (click)="redirectToTransactions()"
    class="transition-all duration-200 mx-4 my-2 block py-2 font-normal text-center text_white hover:text_black button_color_customize hover:button_color_customize font-medium rounded-lg">
    <div class="inline-flex items-center">
      Ver más
    </div>
  </a>
</div>